export const isEmail = (email: unknown): email is string =>
  typeof email === "string" && email.length > 0
    ? /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{2,})+$/i.test(email)
    : false;

export const isUrl = (url: string): boolean =>
  url ? url.length < 2084 && /^(?:http(s)?:\/\/)?[^ \\/]+(?:\.[\w.-]+)+[^ ]+$/.test(url) : false;
